var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.brand === 'COTTI')?_c('CottiService'):_c('TeacatService')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }